export default __webpack_public_path__ + "static/media/auth_diag.b6c52067.png";